// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => GoalSettingStatus.loadInternal(), entryList => {
        GoalSettingStatus.θentryList.set(entryList)
        GoalSettingStatus.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class GoalSettingStatus {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label", "employeeCanEdit", "managerCanSeeRejectionComments", "employeeCanSeeRejectionComments", "employeeCanSeeEmployeeReview", "managerCanSeeEmployeeReview", "managerCanSeeManagerReview", "employeeCanSeeManagerReview", "employeeShouldAct", "managerShouldAct", "nextAction"] as const,
        allPropertyNames: ["id", "label", "employeeCanEdit", "managerCanSeeRejectionComments", "employeeCanSeeRejectionComments", "employeeCanSeeEmployeeReview", "managerCanSeeEmployeeReview", "managerCanSeeManagerReview", "employeeCanSeeManagerReview", "employeeShouldAct", "managerShouldAct", "nextAction"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<GoalSettingStatus.Id | null>;
    static readonly Id = String;
    static ids: GoalSettingStatus.Id[] = [] as any;
    static idsAndDisplayValues: Record<GoalSettingStatus.Id, string> = {} as any;
    static θentryList = signal<GoalSettingStatus.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<GoalSettingStatus.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.label : undefined
    });
    readonly θemployeeCanEdit = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.employeeCanEdit : undefined
    });
    readonly θmanagerCanSeeRejectionComments = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.managerCanSeeRejectionComments : undefined
    });
    readonly θemployeeCanSeeRejectionComments = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.employeeCanSeeRejectionComments : undefined
    });
    readonly θemployeeCanSeeEmployeeReview = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.employeeCanSeeEmployeeReview : undefined
    });
    readonly θmanagerCanSeeEmployeeReview = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.managerCanSeeEmployeeReview : undefined
    });
    readonly θmanagerCanSeeManagerReview = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.managerCanSeeManagerReview : undefined
    });
    readonly θemployeeCanSeeManagerReview = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.employeeCanSeeManagerReview : undefined
    });
    readonly θemployeeShouldAct = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.employeeShouldAct : undefined
    });
    readonly θmanagerShouldAct = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.managerShouldAct : undefined
    });
    readonly θnextAction = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingStatus.getEntryMap()[id]?.nextAction : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return GoalSettingStatus[BoInfoSymbol]
    }

    get __type(): 'Toolbox.GoalSettingStatus' {
        return 'Toolbox.GoalSettingStatus'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.GoalSettingStatus' {
        return 'Toolbox.GoalSettingStatus'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): GoalSettingStatus.Id | null {
        return this.θid()
    }

    set id(id: GoalSettingStatus.Id | GoalSettingStatus | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !GoalSettingStatus.getEntry(id as GoalSettingStatus.Id)) throw new Error('Invalid id for type Toolbox.GoalSettingStatus: ' + id)
        this.θid.set(id as GoalSettingStatus.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): GoalSettingStatus.Id[] {
        return GoalSettingStatus.ids
    }

    get idsAndDisplayValues(): Record<GoalSettingStatus.Id, string> {
        return GoalSettingStatus.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[GoalSettingStatus.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get employeeCanEdit() {
        return this.θemployeeCanEdit()
    }

    get managerCanSeeRejectionComments() {
        return this.θmanagerCanSeeRejectionComments()
    }

    get employeeCanSeeRejectionComments() {
        return this.θemployeeCanSeeRejectionComments()
    }

    get employeeCanSeeEmployeeReview() {
        return this.θemployeeCanSeeEmployeeReview()
    }

    get managerCanSeeEmployeeReview() {
        return this.θmanagerCanSeeEmployeeReview()
    }

    get managerCanSeeManagerReview() {
        return this.θmanagerCanSeeManagerReview()
    }

    get employeeCanSeeManagerReview() {
        return this.θemployeeCanSeeManagerReview()
    }

    get employeeShouldAct() {
        return this.θemployeeShouldAct()
    }

    get managerShouldAct() {
        return this.θmanagerShouldAct()
    }

    get nextAction() {
        return this.θnextAction()
    }

    get isDraft() {
        return this.id == 'draft'
    }

    static get Draft() {
        return new this('draft')
    }

    get isGoalsSubmitted() {
        return this.id == 'goalsSubmitted'
    }

    static get GoalsSubmitted() {
        return new this('goalsSubmitted')
    }

    get isGoalsRejected() {
        return this.id == 'goalsRejected'
    }

    static get GoalsRejected() {
        return new this('goalsRejected')
    }

    get isGoalsApproved() {
        return this.id == 'goalsApproved'
    }

    static get GoalsApproved() {
        return new this('goalsApproved')
    }

    get isSelfReviewPending() {
        return this.id == 'selfReviewPending'
    }

    static get SelfReviewPending() {
        return new this('selfReviewPending')
    }

    get isSelfReviewDone() {
        return this.id == 'selfReviewDone'
    }

    static get SelfReviewDone() {
        return new this('selfReviewDone')
    }

    get isManagerReviewDone() {
        return this.id == 'managerReviewDone'
    }

    static get ManagerReviewDone() {
        return new this('managerReviewDone')
    }

    get isClosed() {
        return this.id == 'closed'
    }

    static get Closed() {
        return new this('closed')
    }

    constructor(idOrObject: GoalSettingStatus.Id | GoalSettingStatus | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingStatus.Entry[] {
        return This.GoalSettingStatus.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingStatus.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: GoalSettingStatus.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof GoalSettingStatus.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = GoalSettingStatus.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<GoalSettingStatus.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new GoalSettingStatus(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: GoalSettingStatus.Id | GoalSettingStatus | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as GoalSettingStatus.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: GoalSettingStatus.Id | GoalSettingStatus) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<GoalSettingStatus.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.GoalSettingStatus yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setDraft() {
        this.id = 'draft'

    }

    setGoalsSubmitted() {
        this.id = 'goalsSubmitted'

    }

    setGoalsRejected() {
        this.id = 'goalsRejected'

    }

    setGoalsApproved() {
        this.id = 'goalsApproved'

    }

    setSelfReviewPending() {
        this.id = 'selfReviewPending'

    }

    setSelfReviewDone() {
        this.id = 'selfReviewDone'

    }

    setManagerReviewDone() {
        this.id = 'managerReviewDone'

    }

    setClosed() {
        this.id = 'closed'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "draft", label: "Draft", employeeCanEdit: true, managerCanSeeRejectionComments: false, employeeCanSeeRejectionComments: false, employeeCanSeeEmployeeReview: false, managerCanSeeEmployeeReview: false, managerCanSeeManagerReview: false, employeeCanSeeManagerReview: false, employeeShouldAct: true, managerShouldAct: false, nextAction: "submit the goal setting" }),
            Object.freeze({ id: "goalsSubmitted", label: "Goals submitted", employeeCanEdit: false, managerCanSeeRejectionComments: true, employeeCanSeeRejectionComments: false, employeeCanSeeEmployeeReview: false, managerCanSeeEmployeeReview: false, managerCanSeeManagerReview: false, employeeCanSeeManagerReview: false, employeeShouldAct: false, managerShouldAct: true, nextAction: "approve the goal setting" }),
            Object.freeze({ id: "goalsRejected", label: "Goals rejected", employeeCanEdit: true, managerCanSeeRejectionComments: true, employeeCanSeeRejectionComments: true, employeeCanSeeEmployeeReview: false, managerCanSeeEmployeeReview: false, managerCanSeeManagerReview: false, employeeCanSeeManagerReview: false, employeeShouldAct: true, managerShouldAct: false, nextAction: "re-submit the goal setting" }),
            Object.freeze({ id: "goalsApproved", label: "Goals approved", employeeCanEdit: false, managerCanSeeRejectionComments: false, employeeCanSeeRejectionComments: false, employeeCanSeeEmployeeReview: false, managerCanSeeEmployeeReview: false, managerCanSeeManagerReview: false, employeeCanSeeManagerReview: false, employeeShouldAct: false, managerShouldAct: false, nextAction: "" }),
            Object.freeze({ id: "selfReviewPending", label: "Self review pending", employeeCanEdit: false, managerCanSeeRejectionComments: false, employeeCanSeeRejectionComments: false, employeeCanSeeEmployeeReview: true, managerCanSeeEmployeeReview: false, managerCanSeeManagerReview: false, employeeCanSeeManagerReview: false, employeeShouldAct: true, managerShouldAct: false, nextAction: "self-review the performance" }),
            Object.freeze({ id: "selfReviewDone", label: "Self review done", employeeCanEdit: false, managerCanSeeRejectionComments: false, employeeCanSeeRejectionComments: false, employeeCanSeeEmployeeReview: true, managerCanSeeEmployeeReview: true, managerCanSeeManagerReview: true, employeeCanSeeManagerReview: false, employeeShouldAct: false, managerShouldAct: true, nextAction: "assess the performance" }),
            Object.freeze({ id: "managerReviewDone", label: "Manager review done", employeeCanEdit: false, managerCanSeeRejectionComments: false, employeeCanSeeRejectionComments: false, employeeCanSeeEmployeeReview: true, managerCanSeeEmployeeReview: true, managerCanSeeManagerReview: true, employeeCanSeeManagerReview: true, employeeShouldAct: true, managerShouldAct: false, nextAction: "acknowledge manager's assessment" }),
            Object.freeze({ id: "closed", label: "Closed", employeeCanEdit: false, managerCanSeeRejectionComments: false, employeeCanSeeRejectionComments: false, employeeCanSeeEmployeeReview: true, managerCanSeeEmployeeReview: true, managerCanSeeManagerReview: true, employeeCanSeeManagerReview: true, employeeShouldAct: false, managerShouldAct: false, nextAction: undefined })
        ] as GoalSettingStatus.Entry[]) as GoalSettingStatus.Entry[]
    }
}
jsonClass('Toolbox.GoalSettingStatus')(GoalSettingStatus)

export const GoalSettingStatusθId = String;

export type GoalSettingStatusθId = string;

export namespace GoalSettingStatus {
    export type Id = 'draft' | 'goalsSubmitted' | 'goalsRejected' | 'goalsApproved' | 'selfReviewPending' | 'selfReviewDone' | 'managerReviewDone' | 'closed'

    export interface Entry {
        id: GoalSettingStatus.Id;
        label: string;
        employeeCanEdit: boolean;
        managerCanSeeRejectionComments: boolean;
        employeeCanSeeRejectionComments: boolean;
        employeeCanSeeEmployeeReview: boolean;
        managerCanSeeEmployeeReview: boolean;
        managerCanSeeManagerReview: boolean;
        employeeCanSeeManagerReview: boolean;
        employeeShouldAct: boolean;
        managerShouldAct: boolean;
        nextAction: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => GoalSettingStatus.load(true))
